import { Box, Button, Checkbox, FormControlLabel, Grow, Modal, styled, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./actionModalStyle.css";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as Flag } from "../../../../../assets/My_Binnys_Access/indiaFlag.svg";
import { getIcon } from "../../../../../utils/iconsConfig";
import apiClient from "lib/api-client";
import { toast } from "react-toastify";

const ActionModal = ({ openModal, handleClose, data, selectAction, setLoader, refetch }) => {
  // let formattedMobileNumbers = data?.mobileNo?.map((str) => {
  //   if (str.startsWith("91") && str.length > 10) {
  //     return `${str.slice(2)}`;
  //   } else if (str.length <= 10) {
  //     return `${str}`;
  //   } else if (str.startsWith("+91") && str.length > 10) {
  //     return `${str.slice(4)}`;
  //   } else {
  //     return str;
  //   }
  // });

  // let formattedMobileNumbers = data?.mobileNo?.map((str) => {
  //   return str.slice(2);
  // });

  let formattedMobileNumbers = data?.mobileNo?.map((str) => {
    return str?.replace(/\D/g, "").slice(-10);
  });

  const [Emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState([]);
  const [emailShowField, setEmailShowField] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);

  const [mobileNumbers, setMobileNumbers] = useState([]);
  const [mobileInput, setmobileInput] = useState([]);
  const [mobileShowField, setMobileShowField] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMobileNumbers, setSelectedMobileNumbers] = useState([]);

  const phoneRefs = useRef([]);

  const handlemailInput = (e, index) => {
    const updatedInputs = [...emailInput];
    updatedInputs[index] = e.target.value;
    setEmailInput(updatedInputs);
  };

  const handleMobileInput = (value, index) => {
    const updatedMobiles = [...mobileInput];
    // const phoneDigits = value.replace(/^91/, "").replace(/\D/g, "");
    // const phoneDigits = value.slice(2);
    const phoneDigits = value;
    updatedMobiles[index] = phoneDigits;
    setmobileInput(updatedMobiles);
  };

  const handleAddNewEmailInput = () => {
    if (!emailShowField) {
      setEmailShowField(true);
      setEmailInput(Emails.length > 0 ? Emails : [""]);
    } else {
      setEmailInput((prev) => [...prev, ""]);
    }
  };

  const handleDeleteEmailInput = (index) => {
    if (emailInput.length <= 1) {
      const updatedEmails = [...emailInput];
      updatedEmails[index] = "";
      setEmailInput(updatedEmails);
      return;
    }
    setEmailInput((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeletePhoneInput = (index) => {
    if (mobileInput.length <= 1) {
      const updatedMobiles = [...mobileInput];
      updatedMobiles[index] = "";
      setmobileInput(updatedMobiles);
      setMobileShowField(false);
      return;
    }
    setmobileInput((prev) => prev.filter((_, i) => i !== index));
  };

  const handleWhatsappSubmit = async () => {
    setLoader(true);

    const formattedNumbers = selectedMobileNumbers.map((num) => {
      let cleanedNum = num.replace(/\D/g, "");
      if (cleanedNum.length > 11) {
        return cleanedNum;
      }
      return `91${cleanedNum}`;
    });


    let payload = {
      gatiOrderId: data?.gatiOrderId,
      mobileNumbers: formattedNumbers,
    };
    const project = data?.activeTab === "Catalog" ? "Design Web" : "";

    try {
      const response = await apiClient.post(`/api/v3/client/vision_order/sendWhatsAppInvoice${project ? `?project=${project}` : ""}`, payload);

      if (response?.status === 200) {
        setLoader(false);
        setSelectedMobileNumbers([]);
        toast.success("Order Details Send Successfully On MobileNumbers");
      }
      handleClose();
    } catch (error) {
      setLoader(false);
      toast.error("There was a problem sending Order Details");
      handleClose();
    }
  };

  const handleAddNewMobileInput = () => {
    if (!mobileShowField) {
      setMobileShowField(true);
      // setmobileInput(mobileNumbers.length > 0 ? [...mobileNumbers, ""] : ["", ""]);
      setmobileInput(mobileNumbers.length > 0 ? [...data?.mobileNo, ""] : ["", ""]);
    } else {
      setmobileInput((prev) => [...prev, ""]);
    }
  };

  const handleModalClose = () => {
    handleClose();
    setEmails([]);
    setEmailShowField(false);
    setEmailInput([]);
    setMobileNumbers([]);
    setMobileShowField(false);
    setmobileInput([]);
    setSelectedMobileNumbers([]);
    setSelectedEmails([]);
  };

  // const isValidMobile = (num) => /^[6-9]\d{9}$/.test(num);
  const isValidMobile = (num) => /^[6-9]\d{9}$/.test(num);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const invalidMobiles = [];
      const validMobiles = mobileInput.filter((num) => {
        let exactNumber;
        if (num.includes("+91")) {
          exactNumber = num.slice(4);
        } else {
          exactNumber = num.slice(2);
        }

        const valid = isValidMobile(exactNumber);

        if (!valid && num) invalidMobiles.push(num);
        return valid;
      });

      const invalidEmails = [];
      const validEmails = emailInput.filter((email) => {
        const valid = isValidEmail(email);
        if (!valid && email) invalidEmails.push(email);
        return valid;
      });

      // ❌ Stop if there are any invalid inputs
      if (invalidMobiles.length > 0) {
        toast.error("Some Moible Numbers are invalid. Please correct them.");
        return;
      }
      if (invalidEmails.length > 0) {
        toast.error("Some Emails are invalid. Please correct them.");
        return;
      }

      if (selectAction === "whatsapp" && validMobiles?.length === 0) {
        toast.error("Please enter at least one valid 10-digit mobile number");
        setIsLoading(false);
        return;
      }
      if (selectAction === "email" && validEmails?.length === 0) {
        toast.error("Please enter at least one valid email address");
        setIsLoading(false);
        return;
      }

      const payload = {
        clientName: data?.clientName,
        partyNo: data?.partyNo,
        partyCode: data?.partyCode,
        // whatsAppNos: selectAction === "whatsapp" ? validMobiles.map((num) => "91" + num) : data?.mobileNo || [],
        whatsAppNos: selectAction === "whatsapp" ? validMobiles : data?.mobileNo || [],
        emails: selectAction === "email" ? validEmails : data?.email || [],
        myBinnysClientUserRefs: data?.myBinnysClientUserRefs,
      };

      if (data?.activeTab !== "Catalog" && data?.activeTab !== "My Binny's") {
        await apiClient.post("/api/v3/client/vision_order/addNewClientWithMobileEmail", payload);
      }

      if (data?.activeTab === "My Binny's") {
        delete payload["clientName"];
        delete payload["partyNo"];
        delete payload["partyCode"];
        await apiClient.post("/api/v3/client/vision_order/addNewMyBinnysUserWithMobileEmail", payload);
      }

      if (selectAction === "email") {
        setEmailShowField(false);
        setEmails(validEmails);
      } else {
        setMobileShowField(false);
        setMobileNumbers(validMobiles);
      }

      toast.success(selectAction === "email" ? "Emails Updated Successfully" : "Mobile Numbers Updated Successfully");
      refetch();
      handleModalClose();
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const StyledButton = styled(Button)(({ theme }) => ({
    minWidth: "17.8vw",
    minHeight: "2vw",
    backgroundColor: "#50C878",
    borderRadius: ".4vw",
    padding: ".45vw 2vw",
    color: "#000000",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: ".7vw",
    lineHeight: "100%",
    "&:hover": {
      backgroundColor: "#50C878",
      color: "#000000",
    },
    "&.Mui-disabled": {
      backgroundColor: "#444444",
      color: "#000000",
    },
  }));

  const StyledCheckbox = styled(Checkbox)({
    width: "1vw",
    height: "1vw",
    borderRadius: ".3vw",
    border: "0.05vw solid black",
    padding: ".05vw",
    "& svg": {
      display: "none",
    },
    "&:before": {
      content: '"\\2714"',
      color: "white",
      fontSize: ".6vw",
    },
    "&.Mui-checked": {
      backgroundColor: "#50C878",
      border: "0.05vw solid black",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      boxShadow: "none",
    },
  });

  let modalContent;

  switch (selectAction) {
    case "email":
      modalContent = (
        <Box display="flex" justifyContent="center" flexDirection="column" gap=".8vw">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className="modal-title">{emailShowField ? "Add Email" : "Select Email"}</Typography>
            <div className="close-section">
              {data?.activeTab === "Catalog" && Emails?.length === 1 ? null : <button className="addField" onClick={() => handleAddNewEmailInput()}>
                Email +
              </button>}
              <Typography className="modal-close" sx={{ display: emailShowField ? "none" : "flex" }} onClick={() => handleModalClose()}>
                {getIcon("Cross")}
              </Typography>
            </div>
          </Box>

          {emailShowField ? (
            <>
              <div className="fixed-modal-height">
                {emailInput.map((email, index) => (
                  <div key={index} className="input-section">
                    <input type="email" value={email} placeholder="Enter the Email" onChange={(e) => handlemailInput(e, index)} />
                    {(emailInput.length > 0 || email) && <button onClick={() => handleDeleteEmailInput(index)}>{getIcon("DustbinIcon")}</button>}
                  </div>
                ))}
              </div>
              <div className="footer-btn-grp">
                <button
                  className="btn-1"
                  onClick={() => {
                    setEmailShowField(false);
                    setEmailInput([]);
                  }}
                  disabled={isLoading}
                >
                  cancel
                </button>
                <button className="btn-2" onClick={handleSave} disabled={isLoading}>
                  {isLoading ? "Saving..." : "save"}
                </button>
              </div>
            </>
          ) : (
            <>
              {Emails.map((item, index) => (
                <FormControlLabel
                  key={index}
                  name={item}
                  control={<StyledCheckbox />}
                  checked={selectedEmails.includes(item)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedEmails((prev) => [...prev, item]);
                    } else {
                      setSelectedEmails((prev) => prev.filter((email) => email !== item));
                    }
                  }}
                  labelPlacement="start"
                  label={<Typography className="modal-data">{item}</Typography>}
                  className="action-modal-label"
                />
              ))}
              <StyledButton onClick={handleClose} disabled={selectedEmails?.length === 0}>Send Email</StyledButton>
            </>
          )}
        </Box>
      );
      break;

    case "whatsapp":
      modalContent = (
        <Box display="flex" justifyContent="center" flexDirection="column" gap=".8vw">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className="modal-title">{mobileShowField ? "Add Mobile No." : "Select Mobile No."}</Typography>
            <div className="close-section">
              {data?.activeTab === "Catalog" && mobileNumbers?.length === 1 ? null : <button className="addField" onClick={() => handleAddNewMobileInput()}>
                Mobile +
              </button>}
              <Typography
                className="modal-close"
                sx={{ display: mobileShowField ? "none" : "flex" }}
                onClick={() => {
                  handleModalClose();
                  setSelectedMobileNumbers([]);
                }}
              >
                {getIcon("Cross")}
              </Typography>
            </div>
          </Box>
          {mobileShowField ? (
            <>
              <div className="fixed-modal-height">
                {mobileInput.map((mobile, index) => (
                  <div key={index} className="input-section">
                    <div className="phone-wrapper">
                      <span>
                        <Flag />
                      </span>
                      <div className="phone-box">
                        <PhoneInput
                          country={"in"}
                          disableDropdown={true}
                          countryCodeEditable={false}
                          placeholder=""
                          //  value={
                          //     mobile && mobile?.split("91")?.length > 1
                          //       ? `+91${mobile?.split("91")[1]}`
                          //       : `+91 ${mobile?.split("91")[0]}`
                          //   }
                          value={mobile && mobile?.startsWith("91") ? `+${mobile}` : mobile?.startsWith("+91") ? `91${mobile?.slice(4)}` : `+91 ${mobile}`}
                          onChange={(value) => handleMobileInput(value, index)}
                          inputProps={{
                            ref: (el) => (phoneRefs.current[index] = el),
                          }}
                        />
                        {!mobile && (
                          <span onClick={() => phoneRefs.current[index]?.focus()} className="placeHolder">
                            Enter your phone No.
                          </span>
                        )}
                      </div>
                    </div>
                    {/* Show delete button for all fields except when it's the only empty field */}
                    {(mobileInput?.length > 1 || mobile) && <button onClick={() => handleDeletePhoneInput(index)}>{getIcon("DustbinIcon")}</button>}
                  </div>
                ))}
              </div>
              <div className="footer-btn-grp">
                <button
                  className="btn-1"
                  onClick={() => {
                    setMobileShowField(false);
                    setmobileInput([]);
                  }}
                  disabled={isLoading}
                >
                  cancel
                </button>
                <button className="btn-2" onClick={handleSave} disabled={isLoading}>
                  {isLoading ? "Saving..." : "save"}
                </button>
              </div>
            </>
          ) : (
            <>
              {mobileNumbers?.map((item, index) => (
                <FormControlLabel
                  key={index}
                  name={item}
                  control={<StyledCheckbox />}
                  checked={selectedMobileNumbers.includes(item)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedMobileNumbers((prev) => [...prev, item]);
                    } else {
                      setSelectedMobileNumbers((prev) => prev.filter((num) => num !== item));
                    }
                  }}
                  labelPlacement="start"
                  label={<Typography className="modal-data">{`+91 ${item}`}</Typography>}
                  className="action-modal-label"
                />
              ))}
              <StyledButton onClick={handleWhatsappSubmit} disabled={selectedMobileNumbers.length === 0}>
                Send Whatsapp
              </StyledButton>
            </>
          )}
        </Box>
      );
      break;

    default:
      modalContent = <></>;
  }

  useEffect(() => {
    if (selectAction === "email") {
      setEmails(data?.email || []);
    } else if (selectAction === "whatsapp") {
      setMobileNumbers(formattedMobileNumbers || []);
    }
  }, [selectAction, data]);

  useEffect(() => {
    phoneRefs.current = phoneRefs.current.slice(0, mobileInput.length);
  }, [mobileInput.length]);

  return (
    <Modal open={openModal} onClose={handleModalClose} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Grow in={openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            bgcolor: "white",
            borderRadius: ".6vw",
            p: ".75vw",
            outline: "none",
            border: "none",
            minWidth: "1.4vw",
            marginX: "auto",
          }}
        >
          {modalContent}
        </Box>
      </Grow>
    </Modal>
  );
};

export default ActionModal;
